"use client";

import Heading from "@/components/heading/heading";

import Image from "next/image";

import "@/styles/common/typo.scss";
import "@/sections/common/top-recommended/top-recommended.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation } from "swiper/modules";
import { getImageUrl } from "@/utils/imageUrl";

const TopRecommendedList = [
    
     {
        name: "Flame Towers",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/flametowers.jpeg"),
        location: "",
    },
    {
        name: "Baku Eye",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/baku.webp"),
        location: "",
    },
    {
        name: "Carpet Museum",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/carpetmuseum.png"),
        location: "",
    },
    {
        name: "Little Venice",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/littlevenice.png"),
        location: "",
    },
    {
        name: "Ichari Seher (Old City)",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/icharisehar.jpeg"),
        location: "",
    },
    {
        name: "Maiden Tower",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/maidentower.jpeg"),
        location: "",
    },
    {
        name: "Shirvanshah Palace",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/shirvanshahpalace.jpeg"),
        location: "",
    },
    {
        name: "Gobustan Mud Volcano",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/gobustanmud.png"),
        location: "",
    },
    {
        name: "Gobustan Museum",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/gobustanmuseum.png"),
        location: "",
    },
    {
        name: "Shahdag Mountain Resort",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/shahdagmountainresort.jpeg"),
        location: "",
    },
    {
        name: "Chanlibel Lake",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/chanlibellake.jpeg"),
        location: "",
    },
    {
        name: "Nohurgol Lake",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/nohurgollake.jpeg"),
        location: "",
    },
    {
        name: "Lavender Farm",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/lavenderfarm.jpeg"),
        location: "",
    },
    {
        name: "Alpaca Farm",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/alpacafarm.png"),
        location: "",
    },
    {
        name: "Yanar Dag",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/yanardag.jpeg"),
        location: "",
    },
    {
        name: "Ateshgah Fire Temple",
        picture: getImageUrl("/pages/azerbaijan/main-page/images/top-recommended/ateshgah.jpeg"),
        location: "",
    },
];

const TopRecommended = () => {
    return (
        <section className="top-recommended-section flex items-center py-10 md:py-20 gap-6">
            <div className="top-recommended-info flex flex-col gap-4 container-start">
                <div className="form-title flex flex-col">
                    <Heading as="h3" className="font-yesteryear font-extralight">
                        Top Recommended
                    </Heading>
                    <Heading as="h2" className="text-white">
                        Must Do Things
                    </Heading>
                </div>
                <p className="lead">
                Uncover diverse cultures, savor local flavors, and wander through stunning landscapes.
                </p>
                <div className="swiper-pagination-wrapper flex items-center gap-2 mt-2">
                    <div className="pagination-arrows flex items-center gap-3 sm:gap-4">
                        <figure className="pagination-left-top-recommended flex-center">
                            <Image loading="lazy"
                                src={getImageUrl("/svg/paginarition-arrow-left.svg")}
                                alt="Pagination Left"
                                width={24}
                                height={24}
                            />
                        </figure>
                        <figure className="pagination-right-top-recommended flex-center">
                            <Image loading="lazy"
                                src={getImageUrl("/svg/paginarition-arrow-right.svg")}
                                alt="Pagination Right"
                                width={24}
                                height={24}
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <div className="top-recommended-slider pl-4">
                <Swiper
                    spaceBetween={16}
                    slidesPerView={1}
                    navigation={{
                        nextEl: ".pagination-right-top-recommended",
                        prevEl: ".pagination-left-top-recommended",
                        enabled: true,
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        480: {
                            slidesPerView: 2,
                        },
                        767: {
                            slidesPerView: 3,
                        },
                        1023: {
                            slidesPerView: 2,
                        },
                        1279: {
                            slidesPerView: 3,
                        },
                        1535: {
                            slidesPerView: 4,
                        },
                    }}
                    className="top-recommended-swiper"
                >
                    {TopRecommendedList.map((t, index) => {
                        return (
                            <SwiperSlide
                                key={index}
                                className="top-recommended-slide"
                            >
                                <a
                                    
                                    className="inline-flex flex-col gap-6"
                                >
                                    <figure>
                                        <Image loading="lazy"
                                            src={t.picture}
                                            alt={t.name}
                                            width={400}
                                            height={300}
                                            
                                        />
                                        <figcaption className="flex flex-col items-start justify-end p-4">
                                            <Heading
                                                as="h6"
                                                className="text-white"
                                            >
                                                {t.name}
                                            </Heading>
                                            <span className="font-light text-white">
                                                {t.location}
                                            </span>
                                        </figcaption>
                                    </figure>
                                </a>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </section>
    );
};

export default TopRecommended;
